import React from 'react';
import * as Icon from 'react-feather';

/**
 * Allowlist of icon names that Access Control may store for modules/pages (PRD Screen 1).
 * Icon names from the database are looked up here — never evaluated as code.
 */
export const MENU_ICONS = {
  Box: Icon.Box,
  Package: Icon.Package,
  Bell: Icon.Bell,
  Shield: Icon.Shield,
  Home: Icon.Home,
  Truck: Icon.Truck,
  FileText: Icon.FileText,
  GitPullRequest: Icon.GitPullRequest,
  CheckCircle: Icon.CheckCircle,
  Clock: Icon.Clock,
  Settings: Icon.Settings,
  Droplet: Icon.Droplet,
  Wind: Icon.Wind,
  Cpu: Icon.Cpu,
  Zap: Icon.Zap,
  ShoppingCart: Icon.ShoppingCart,
  Copy: Icon.Copy,
  HardDrive: Icon.HardDrive,
  Database: Icon.Database,
  Grid: Icon.Grid,
  List: Icon.List,
  User: Icon.User,
  Users: Icon.Users,
  Tool: Icon.Tool,
  Clipboard: Icon.Clipboard,
  Calendar: Icon.Calendar,
  BarChart2: Icon.BarChart2,
  Layers: Icon.Layers,
  Printer: Icon.Printer,
  Archive: Icon.Archive,
  Lock: Icon.Lock,
  Key: Icon.Key,
  Eye: Icon.Eye,
};

export const MENU_ICON_NAMES = Object.keys(MENU_ICONS);

export const renderMenuIcon = name => {
  const Component = MENU_ICONS[name] || Icon.Circle;
  return <Component />;
};
